import ExperimentQueryParamsHandlerComponent from './ExperimentQueryParamsHandler';

export { ExperimentQueryParamsHandlerComponent as ExperimentQueryParamsHandler };
export default ExperimentQueryParamsHandlerComponent;
